import { render } from "./TextReaderProvincia.vue?vue&type=template&id=1c7054ca"
import script from "./TextReaderProvincia.vue?vue&type=script&lang=js"
export * from "./TextReaderProvincia.vue?vue&type=script&lang=js"

import "./TextReaderProvincia.vue?vue&type=style&index=0&id=1c7054ca&lang=css"

import exportComponent from "C:\\SistemasProyectos\\AppWeb\\historiaClinica\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__